import { Otras_solicitudes } from '../../../models/otras_solicitudes.model';
import { Component } from "@angular/core";
import * as moment from 'moment'
import {  FormControl, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';

@Component({
    selector: "page-otras_solicitudes",
    templateUrl: "./otras_solicitudes.component.html",
    styleUrls: ["./otras_solicitudes.component.css"],
    providers: [FormService]
})

export class Otras_solicitudesComponent {
      public rows = [];
      public actualRow;
      public otras_solicitudes: Otras_solicitudes;
      public form;
      public matcher = new FormService();

      public fecha_fusion;
      public fecha_cambio;
      public fecha_loteo;
      public maxDate;

      constructor(){
        this.maxDate = moment().toDate()

        this.form = new FormGroup({
            tramitacion_conj1: new FormControl(''),
            tramitacion_conj2: new FormControl(''),
            tramitacion_conj3: new FormControl(''),
            tramitacion_conj4: new FormControl(''), 
            fusion: new FormControl(''), 
            solicitud_fusion: new FormControl(''), 
            fecha_fusion: new FormControl({value: '', disabled:true}),
            cambio: new FormControl(''), 
            solicitud_cambio: new FormControl(''), 
            fecha_cambio: new FormControl({value: '', disabled:true}),
            otras: new FormControl(''),
            loteo: new FormControl(''), 
            solicitud_loteo: new FormControl(''), 
            fecha_loteo: new FormControl({value: '', disabled:true})
                 
        })
        if(!JSON.parse(localStorage.getItem("otras_solicitudes"))){
            localStorage.setItem("otras_solicitudes", JSON.stringify(this.rows));
        }else{
            this.rows = JSON.parse(localStorage.getItem("otras_solicitudes"));
            this.form.controls['tramitacion_conj1'].setValue(this.rows[0]?this.rows[0].tramitacion_conj1:false);
            this.form.controls['tramitacion_conj2'].setValue(this.rows[0]?this.rows[0].tramitacion_conj2:false);
            this.form.controls['tramitacion_conj3'].setValue(this.rows[0]?this.rows[0].tramitacion_conj3:false);
            this.form.controls['tramitacion_conj4'].setValue(this.rows[0]?this.rows[0].tramitacion_conj4:false);
            this.form.controls['fusion'].setValue(this.rows[0]?this.rows[0].fusion:false);
            this.form.controls['solicitud_fusion'].setValue(this.rows[0]?this.rows[0].solicitud_fusion:'');
            this.form.controls['fecha_fusion'].setValue(this.rows[0]?this.rows[0].fecha_fusion:null);
            this.form.controls['cambio'].setValue(this.rows[0]?this.rows[0].cambio:false);
            this.form.controls['solicitud_cambio'].setValue(this.rows[0]?this.rows[0].solicitud_cambio:'');
            this.form.controls['fecha_cambio'].setValue(this.rows[0]?this.rows[0].fecha_cambio:null);
            this.form.controls['otras'].setValue(this.rows[0]?this.rows[0].otras:false);
            this.form.controls['loteo'].setValue(this.rows[0]?this.rows[0].loteo:false);
            this.form.controls['solicitud_loteo'].setValue(this.rows[0]?this.rows[0].solicitud_loteo:'');
            this.form.controls['fecha_loteo'].setValue(this.rows[0]?this.rows[0].fecha_loteo:null);
        }
        this.otras_solicitudes = {tramitacion_conj1:'',tramitacion_conj2:'',tramitacion_conj3:'',tramitacion_conj4:'',fusion:'',solicitud_fusion:'',fecha_fusion:null,cambio:'',solicitud_cambio:'',fecha_cambio:null,otras:'',loteo:'',solicitud_loteo:'',fecha_loteo:null};
    }

    add_otras_solicitudes(event?: MatDatepickerInputEvent<Date>, type?){
        if(event){
            
            this.fecha_fusion = moment(event.value).format('DD/MM/YYYY')
            this.fecha_cambio = moment(event.value).format('DD/MM/YYYY')
            this.fecha_loteo = moment(event.value).format('DD/MM/YYYY')
        } 
        else {
            var temp = JSON.parse(localStorage.getItem("otras_solicitudes"))
            if(temp > 0){
                this.fecha_fusion= temp[0].fecha,
                this.fecha_cambio= temp[0].fecha_cambio
                this.fecha_loteo= temp[0].escritura
            }else {
                this.fecha_fusion = ''
                this.fecha_cambio = ''
                this.fecha_loteo = ''
            }
            
        }
        localStorage.setItem("otras_solicitudes",JSON.stringify([]));
        this.actualRow = localStorage.getItem("otras_solicitudes");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            tramitacion_conj1: this.form.value.tramitacion_conj1,
            tramitacion_conj2: this.form.value.tramitacion_conj2,
            tramitacion_conj3: this.form.value.tramitacion_conj3,
            tramitacion_conj4: this.form.value.tramitacion_conj4,
            fusion: this.form.value.fusion,
            solicitud_fusion: this.form.value.solicitud_fusion, 
            fecha_fusion: moment(this.form.value.fecha_fusion).format("DD/MM/YYYY"),
            cambio: this.form.value.cambio, 
            solicitud_cambio: this.form.value.solicitud_cambio, 
            fecha_cambio:  moment(this.form.value.fecha_cambio).format("DD/MM/YYYY"),
            otras: this.form.value.otras,
            loteo: this.form.value.loteo,
            solicitud_loteo: this.form.value.solicitud_loteo, 
            fecha_loteo: moment(this.form.value.fecha_loteo).format("DD/MM/YYYY")
        })
        localStorage.setItem("otras_solicitudes", JSON.stringify(this.rows));
    }

    delete_otras_solicitudes(id){
        for(let x = 0; x < this.rows.length; x++){
            if(id == x){
                this.rows.splice(x, 1);
                localStorage.setItem("otras_solicitudes", JSON.stringify(this.rows));
            }
        }
    }

}